// extracted by mini-css-extract-plugin
module.exports = {"picture":"picture_picture__321B2","logo":"picture_logo__3y2QY","login":"picture_login__3q3xq","user":"picture_user__CYpql"};